var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-layout',{attrs:{"fill-height":""}},[(_vm.showSp)?_c('SP'):_c('MainActivity',{attrs:{"app":null}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }